import React from 'react';

interface PermissionsIconProps {
  isActive?: boolean;
}

export const PermissionsIcon: React.FC<PermissionsIconProps> = ({ isActive = false }) => {
  const stroke = isActive ? '#1a7ffd' : '#8c8c8c';
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2L19 5V11C19 16 15.8 20.4 12 22C8.2 20.4 5 16 5 11V5L12 2Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 12.5L11 14L14.5 10.5"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PermissionsIcon;

